import Page from './Page.js';
import Slider from './Slider.js';

/**
 * Class Pepzine
 */
class Pepzine extends Page {


  /**
   * Constructor
   */
  constructor(currentPageId){
    super();
    // Properties
    this.currentPageId = currentPageId;
    this.content = {};
  }


  /**
   * Init
   */
  init() {
  }


  /**
   * Set events listeners
   */
  setEventsListeners() {
    this.slider = new Slider();
    // Listeners
    this.resizeSliderListener = this.slider.resize.bind(this.slider);
    this.prevSlideListener = this.slider.prev.bind(this.slider);
    this.nextSlideListener = this.slider.next.bind(this.slider);
    document
      .getElementById("pepzine-prev-slide")
      .addEventListener("click", this.prevSlideListener, false);
    document
      .getElementById("pepzine-next-slide")
      .addEventListener("click", this.nextSlideListener, false);
    window.addEventListener("resize", this.resizeSliderListener, false);
  }


  /**
   * Unset events listeners
   */
  unsetEventsListeners() {
    document
      .getElementById("pepzine-prev-slide")
      .removeEventListener("click", this.prevSlideListener, false);
    document
      .getElementById("pepzine-next-slide")
      .removeEventListener("click", this.nextSlideListener, false);
    window.removeEventListener("resize", this.resizeSliderListener, false);
  }

  resizeSlider() {
    // @TODO: Refactor a load realisations list item event;
		var e = document.createEvent("CustomEvent");
		e.initCustomEvent('pepzine_slider_resize_call', false, false, {});
    window.dispatchEvent(e);
  }


  /**
   * Go
   */
  go(){
    this.getPageContent();
  }


  /**
   * Get page content
   */
  getPageContent() {
    console.log("get page content");

    this.ajax("https://pepscreation.com/wp-json/wp/v2/pages?slug=pepzine").then(
      function(result) {
        var data = JSON.parse(result);
        this.content = data[0].acf;
        this.content.pepzine_request_form = data[0].content.rendered
          .replace(/action\=\"([\s\S]*?)\"/i, 'action="/pepzine"');
        // getaway
        this.display();
      }.bind(this)
    ).catch(function(msg) {
      console.log(msg);
    });

  }

  /**
   * Display
   */
  display() {
    console.log("display");

    console.log("prepare slides data");
    var sliderListTemplate = ``;
    var sliderItemsTemplate = ``;
    var rawSlides = document.createElement('div');
    rawSlides.innerHTML = this.content.pepzine_covers_slider;
    var slidesData = rawSlides.getElementsByTagName("img");
    var slides = [];
    for (var i=0; i<=2; i++) {
      sliderListTemplate
        += `<img
        src="${slidesData[i].src}"
        alt="${slidesData[i].alt}"
        >`;
    }
    for (var i=0; i<slidesData.length; i++) {
      sliderItemsTemplate
        += `<img
        src="${slidesData[i].src}"
        alt="${slidesData[i].alt}"
        >`;
    }

    var template = `
      <div id="pepzine-page" class="page">
      <section id="pepzine-header">
      <img
      src="/wp-content/themes/pepscreation/img/pepzine.gif"
      alt="realisations">
      <p>${this.content.pepzine_header_text}</p>
      </section>
      <section id="pepzine-list-container">
      <div id="pepzine-list">
      <div id="pepzine-slider-container">
      <div id="pepzine-slider">`;

    template += sliderListTemplate;

    template +=`
      </div>
      </div>
      <div id="pepzine-slider-items">`;

    template += sliderItemsTemplate;

    template +=`
      </div>
      </div>
      <div id="pepzine-list-shadows">
      <img
      src="/wp-content/themes/pepscreation/img/pepzine-item-shadow.jpg"
      alt=""
      ><img
      src="/wp-content/themes/pepscreation/img/pepzine-item-shadow.jpg"
      alt=""
      ><img
      src="/wp-content/themes/pepscreation/img/pepzine-item-shadow.jpg"
      alt="">
      </div>
      <a class="pepzine-slide-nav" id="pepzine-prev-slide" href="javascript: void(0);">
      <img
      src="/wp-content/themes/pepscreation/img/prev.png"
      alt="prev">
      </a>
      <a class="pepzine-slide-nav" id="pepzine-next-slide" href="javascript: void(0);">
      <img
      src="/wp-content/themes/pepscreation/img/next.png"
      alt="next">
      </a>
      </section>
      <div id="pepzine-bottom-container">
      <section class="pepzine-bottom-col" id="pepzine-extract">
      <span class="title">${this.content.pepzine_extract_title}</span>
      <div class="arrow"> </div>
      <a id="pepzine-extract-link"
      href="${this.content.pepzine_extract_file}"
      target="_blank">
      <img
      src="/wp-content/themes/pepscreation/img/mag_pepzine.png"
      alt="realisations">
      </a>
      </section>
      <section class="pepzine-bottom-col" id="pepzine-request">
      <div class="row">
      <div class="span-col-12">
      <span class="title">${this.content.pepzine_request_title}</span>
      </div>
      </div>
      ${this.content.pepzine_request_form}
      </section>
      </div>
      `;

    // set page meta
    document.getElementById(this.currentPageId).setAttribute("id", "pepzine-page-container");
    this.currentPageId = "pepzine-page-container";

    // Send built event
		var e = document.createEvent("CustomEvent");
		e.initCustomEvent('page_built', false, false, {
			'slug': '/pepzine',
      'template': template
		});
    window.dispatchEvent(e);
  }

}

export default Pepzine;


